import { useEffect } from 'react';

import { useConfigStore } from '@packages/stores';
import { createSortKeyByUUID } from '@packages/utils';

import { AutoDiscountCard, QuoteFlowContainer, TripDetails } from '@components';
import { GetQuoteProvider } from '@components/getQuoteProvider';
import { PreTripCancellation } from '@components/preTripCancellation';
import { TotalPriceAndGroupDiscount } from '@components/sideBar/totalPriceAndGroupDiscount';
import { TripCostEditor } from '@components/tripCostEditor/tripCostEditor.component';
import { useCruiseBoostPopUp, useMedalliaScript } from '@hooks';
import { setTag } from '@sentry/react';
import { useTripStore } from '@store';
import '@store/trip/trip.subscriptions';
import { sendAnalyticsMyQuotePageView } from '@utils';

import { AdditionalInformation } from './additionalInformation/additionalInformation.component';
import { Benefits } from './benefits/benefits.component';
import { ChooseYourExcess } from './chooseYourExcess/chooseYourExcess.component';
import { DailyCoverSection } from './dailyCover/dailyCoverSection.component';
import { ExtraCoverSection } from './extraCover/extraCoverSection.component';

export const MyQuote = () => {
  const QUOTE_IMAGE_TAG = useConfigStore(
    state => state.regionSpecificConfig?.MARKETING_IMAGE_TAGS?.quote,
  );
  const totalTripCost = useTripStore(state => {
    const tripCost = state?.trip?.totalTripCost;
    return tripCost ? tripCost.toString() : '';
  });
  const tripType = useTripStore(state => state?.trip?.tripType);
  //we need to rerender trip cost form once trip is updated to make sure it shows default trip cost based on the number travellers
  const boostId = useTripStore(state => state?.trip?.boosts?.[0]?.boostId);
  useMedalliaScript();

  useCruiseBoostPopUp();
  useEffect(() => {
    setTag('section', 'boostSelection');
    sendAnalyticsMyQuotePageView();
  }, []);

  return (
    <>
      {QUOTE_IMAGE_TAG && (
        <img
          src={QUOTE_IMAGE_TAG?.replace('[OrderID]', createSortKeyByUUID())}
          width="1"
          height="1"
          alt=""
          className="absolute -top-96 -left-96"
        />
      )}
      <GetQuoteProvider
        key={boostId}
        defaultFormValues={{ totalTripCost }}
        mode="onSubmit"
        reValidateMode="onChange">
        <QuoteFlowContainer>
          <ChooseYourExcess key={tripType} />
          <TripCostEditor />
          <PreTripCancellation />
          <Benefits />
          <ExtraCoverSection />
          <DailyCoverSection />
          <AdditionalInformation />
          <TripDetails className="relative pt-4 mt-6 border-t lg:hidden" />
          <AutoDiscountCard className="lg:hidden" />
          <TotalPriceAndGroupDiscount showAfterPay className="lg:hidden" />
        </QuoteFlowContainer>
      </GetQuoteProvider>
    </>
  );
};
